// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__Option from "melange/option.js";

function time(value, key) {
  const time$1 = Js__Js_json.decodeNumber(Mapre_wire__Json.get(value, key));
  if (time$1 !== undefined) {
    if (Stdlib__Float.is_finite(time$1) && time$1 > 0) {
      return time$1;
    }
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_recovery_time"
      });
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_recovery_time"
    });
}

function count(value, key, maximum) {
  const count$1 = Mapre_wire__Json.integer(value, key);
  if (count$1 < 0 || count$1 > maximum) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_backup_count"
      });
  }
  return count$1;
}

function backup(value) {
  const match = Mapre_wire__Json.string(value, "state");
  switch (match) {
    case "blocked" :
      return /* Blocked */ 2;
    case "expired" :
      return /* Expired */ 3;
    case "pending" :
      return /* Pending */ 1;
    case "unavailable" :
      return /* Unavailable */ 0;
    case "verified" :
      return {
        TAG: /* Verified */ 0,
        _0: {
          files: count(value, "file_count", 4096),
          bytes: count(value, "byte_count", 104857600),
          omissions: count(value, "omission_count", 8192),
          expires: time(value, "expires_at")
        }
      };
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_backup_state"
        });
  }
}

function decode(value) {
  if (Caml_obj.caml_equal(value, null)) {
    return;
  }
  const attempts = Mapre_wire__Json.integer(value, "attempts");
  const maximum = Mapre_wire__Json.integer(value, "max_attempts");
  if (attempts < 0 || attempts > 3 || maximum !== 3) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_recovery_control"
      });
  }
  const snapshot = Mapre_wire__Json.get(value, "snapshot");
  const saved_at = Caml_obj.caml_equal(snapshot, null) ? undefined : time(snapshot, "completed_at");
  const value$1 = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(value, "resource_deleted"));
  let deleted;
  if (value$1 !== undefined) {
    deleted = value$1;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_recovery_cleanup"
      });
  }
  return {
    code: Mapre_wire__Json.string(value, "code"),
    attempts,
    saved_at,
    backup: backup(Mapre_wire__Json.get(value, "backup")),
    deleted
  };
}

function files(count) {
  return String(count) + (
    count === 1 ? " file" : " files"
  );
}

function items(count) {
  return String(count) + (
    count === 1 ? " item" : " items"
  );
}

function backup_description(r) {
  const b = r.backup;
  if (/* tag */ typeof b !== "object" && typeof b !== "function") {
    switch (b) {
      case /* Unavailable */ 0 :
        return "Available small files must be backed up before the failed environment is deleted.";
      case /* Pending */ 1 :
        return "Backing up available small files before deleting this failed environment.";
      case /* Blocked */ 2 :
        return "The backup could not be verified. The failed environment has been kept.";
      case /* Expired */ 3 :
        return "This backup has expired.";
    }
  } else {
    const b$1 = b._0;
    return "Backed up " + (files(b$1.files) + (" (" + (String(b$1.bytes) + (" bytes); skipped " + (items(b$1.omissions) + (". Backup expires: " + (new Date(b$1.expires).toISOString() + ". This is a partial copy of the last saved snapshot.")))))));
  }
}

function description(r) {
  const state = r.code === "recovering" ? "Recovering this environment. Attempt " + (String(r.attempts) + " of 3, with a cooldown before retrying.") : (
      r.code === "recovery_unsupported" ? "This environment cannot be recovered in place. Automatic retries stopped." : "Automatic recovery stopped. This environment needs attention."
    );
  const saved = Stdlib__Option.fold(" No saved checkpoint has been verified.", (function (time) {
    return " Last saved snapshot: " + (new Date(time).toISOString() + ".");
  }), r.saved_at);
  return state + (saved + (" " + (backup_description(r) + ((
    r.deleted ? " Failed environment deleted." : ""
  ) + " Backup files expire within 24 hours."))));
}

export {
  decode,
  description,
}
/* Mapre_wire__Json Not a pure module */
